import apiClient from '../config/axiosConfig';

export const getFmsClientId = () => {
    return apiClient
        .get(`/v3/forms/bridgeId?orgId=${localStorage.getItem('OrganizationId')}&churchId=${localStorage.getItem('GivingChurchId')}`);
};
